/* eslint-disable react/prop-types */
import React, { Fragment, useState, Suspense } from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import NavBar from '../../components/NavBar/NavBar';
import Logo from '../../assets/Images/logo.png';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import WelcomePage from './Contents/WelcomePage';
import Leaf from '../../assets/Images/svg/leaf.svg';
import NotePad from '../../assets/Images/notepad.png';
import OfferedDegreePrograms from './Contents/OfferedDegreePrograms';
import ALevelOfferedDegreePrograms from './Contents/ALevelOfferedDegreePrograms';
import EntryRequirements from './Contents/EntryRequirements';
import ALevelEntryRequirements from './Contents/ALevelEntryRequirements';
import MeritScholarship from './Contents/MeritScholarship';
import ConsultAdmissionCounselor from './Contents/ConsultAdmissionCounselor';
import AdmissionForm from './Contents/AdmissionForm/AdmissionForm';
import AdmissionFormAlevel from './Contents/AdmissionFormAlevel/AdmissionFormAlevel';
import NewAdmission from './Contents/NewAdmission/NewAdmission';
import RegistrationFeePayment from './Contents/RegistrationFeePayment/RegistrationFeePayment';
import UploadDocumentsForm from './Contents/UploadDocuments/UploadDocumentsForm';
import ReviewAdmissionApplication from './Contents/ReviewAdmissionApplication';
import TutionFeePayment from './Contents/TutionFeePayment/TutionFeePayment';
import UploadRaisedDocumentsForm from './Contents/UploadDocuments/UploadRaisedDocumentsForm';

const drawerWidth = 283;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuTitle: {
    backgroundColor: "#103C6E",
    fontFamily: 'sans-serif',
    display: 'flex',
    cursor: "default",
    fontSize: 16,
    fontWeight: 600,
    padding: 5,
    marginTop: 15
  },
  menuItemPadding: {
    padding: '0 !important',
    cursor: "pointer",
  },
  menuTitleIcon: {
    height: 25,
    width: 25,
    marginRight: 10,
    marginLeft: 15
  },
  menuItemText: {
    textAlign: 'left',
    paddingTop: 3,
    paddingBottom: 3,
    color: 'white',
    marginLeft: 40,
    width: drawerWidth - 20,
  },
  active: {
    backgroundColor: "#103C6E",
    paddingRight: 10,
    width: drawerWidth - 20,
    height: 30
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    width: drawerWidth - 10,
  },
  drawerPaper: {
    width: drawerWidth,
    color: '#F5F5F5',
    backgroundColor: '#174A84',
  },
  drawerContainer: {
    overflow: 'auto',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  regular: {
    minHeight: 0
  },
  menuListContainer: {
    borderLeft: '3px solid'
  }
}));

const ProtectedRoute = ({ name, element }) => {
  if ((name === "admission-application" && localStorage.getItem("isSubmitted") == 1) || (name === "documents" && localStorage.getItem("isDocumentRequested") != 1 && localStorage.getItem("isSubmitted") == 1)) {
    return <Navigate to="/dashboard" />;
  }
  return element;
}

const Dashboard = () => {
  const classes = useStyles();
  const location = useLocation();
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const isSubmitted = localStorage.getItem("isSubmitted");
  const isRaisedRequest = localStorage.getItem("isDocumentRequested");
  const isPreviousSessionStudent = localStorage.getItem("isPreviousSessionStudent");

  // Determine viewValue from location
  // location.pathname might be "/dashboard/ug-degree-programs"
  let viewValue = location.pathname.split("/dashboard/")[1] || "welcome";
  // Handle root dashboard path
  if (location.pathname === "/dashboard" || location.pathname === "/dashboard/") {
    viewValue = "welcome";
  }
  // Handle sub-paths cleanly?
  // If path is /dashboard/x/y, viewValue is x/y.
  // The original supported :value in path.

  return (
    <Fragment>
      <NavBar logo={Logo} title="University College London." isAuthorize userName={userData ? userData.displayName : ''} />
      <Drawer
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={Leaf} /> <div>Undergraduate Admission</div>
              </Typography>
              <MenuList>
                <MenuItem className={`${viewValue === "ug-degree-programs" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/ug-degree-programs'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Offered Degree Programs</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "ug-entry-requirements" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/ug-entry-requirements'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Entry Requirements</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "consult-admission-counselor" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/consult-admission-counselor'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Connect with our Counselors
                  </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={Leaf} /> <div>GCE A-Level Admission</div>
              </Typography>
              <MenuList>
                <MenuItem className={`${viewValue === "al-degree-programs" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-degree-programs'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Subject Choices</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "al-entry-requirements" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-entry-requirements'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Entry Requirements</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "al-consult-admission-counselor" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-consult-admission-counselor'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Connect with our Counselors
                  </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={NotePad} /> <div>Online Admission Process</div>
              </Typography>

              <MenuList>
                <MenuItem
                  disabled={isPreviousSessionStudent != 1}
                  className={`${viewValue === "new-admission" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/new-admission'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">New Admission</Typography>
                  </Link>
                </MenuItem>
                <MenuItem disabled={isSubmitted == 1} className={`${viewValue === "admission-application" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/admission-application'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Admission Application</Typography>
                  </Link>
                </MenuItem>
                <MenuItem disabled={isSubmitted == 1 && isRaisedRequest != 1} className={`${viewValue === "documents" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/documents'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Upload Documents</Typography>
                  </Link>
                </MenuItem>

                <MenuItem className={`${viewValue === "review" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/review'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Review & Submit Application
                  </Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${(viewValue === "registration-fee-payment" || viewValue === "registration-fee-payment-success") && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/registration-fee-payment'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Registration Fee Payment
                  </Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${(viewValue === "tuition-fee-payment" || viewValue === "tuition-fee-payment-success") && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/tuition-fee-payment'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Tuition Fee Payment
                  </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

          </div>
          <div style={{ maxWidth: drawerWidth - 15, paddingBottom: 10, paddingTop: 20 }}>
            <Typography variant="body2" style={{ fontSize: 12, color: 'white' }} align="center">
              Copyright © {new Date().getFullYear()}. Universal College Lahore<br></br>(UCL), Pakistan - All Rights Reserved
            </Typography>
          </div>
        </div>
      </Drawer>

      <main className={clsx(classes.content, {
        [classes.contentShift]: isDrawerOpen,
      })}>
        <div className={classes.toolbar} />
        <Suspense fallback={<p>Loading...</p>}>
          <Routes>
            <Route path="/" element={<WelcomePage title={userData ? userData.displayName : ''} />} />
            <Route path="ug-degree-programs" element={<OfferedDegreePrograms />} />
            <Route path="al-degree-programs" element={<ALevelOfferedDegreePrograms />} />
            <Route path="ug-entry-requirements" element={<EntryRequirements />} />
            <Route path="al-entry-requirements" element={<ALevelEntryRequirements />} />
            <Route path="merit-scholarship" element={<MeritScholarship />} />
            <Route path="consult-admission-counselor" element={<ConsultAdmissionCounselor />} />
            <Route path="al-consult-admission-counselor" element={<ConsultAdmissionCounselor />} />
            <Route path="admission-application" element={<ProtectedRoute name="admission-application" element={<AdmissionForm />} />} />
            <Route path="admission-application-alevel" element={<AdmissionFormAlevel />} />
            <Route path="new-admission" element={<NewAdmission />} />
            <Route path="registration-fee-payment" element={<RegistrationFeePayment />} />
            <Route path="registration-fee-payment-success" element={<RegistrationFeePayment success />} />
            <Route path="tuition-fee-payment" element={<TutionFeePayment />} />
            <Route path="tuition-fee-payment-success" element={<TutionFeePayment success />} />
            <Route path="documents" element={
              <ProtectedRoute name="documents" element={
                localStorage.getItem("isDocumentRequested") == 1 ? <UploadRaisedDocumentsForm /> : <UploadDocumentsForm />
              } />
            } />
            <Route path="review" element={<ReviewAdmissionApplication />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Suspense>
      </main>
    </Fragment>
  );
}

export default Dashboard;
